import { randomIndexInArray } from './helpers';

$('.full-width-image').each(function () {
	const $fwi = $(this);
	const $secret = $fwi.find('.full-width-image-secret');

	if (!$secret.length) return;

	const $title = $fwi.find('.full-width-image-title');
	const secretText = $secret.text();
	const secretHtml = secretText.split('').map(char => char.trim() ? `<span>${char}</span>` : `<span class="visible">${char}</span>`).join('');

	$secret.html(secretHtml);

	$fwi.one('click', '.full-width-image-header', function () {
		$title.hide();
		$secret.show();

		let start = null;

		function revealRandomLetter(timestamp) {
			if (!start) start = timestamp;
			const progress = timestamp - start;

			const $remaining = $secret.find('span:not(.visible)');

			if (!$remaining.length) return;

			if (progress > 100) {
				const $letter = $remaining.eq(randomIndexInArray($remaining));
				$letter.addClass('visible');
				start = timestamp;
			}

			requestAnimationFrame(revealRandomLetter);
		}

		requestAnimationFrame(revealRandomLetter);
	});

});